var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 30",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.917l10.082.09 3.63 5.332 3.45-5.511 10.307.134-3.764 4.884v11.158l-9.859 3.002L5.585 25.69V14.892L2 9.917z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.055,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.585 14.891l10.127.448.135 13.667",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.585 14.891l10.127.448.135 13.667M15.712 15.34l9.993-.494M5.002 5.436l2.554 2.15M26.914 5.436l-2.599 2.016M8.856 2.748l3.45 3.988M15.892 1l.134 5.87M22.479 2.3l-2.6 4.301",
    stroke: "currentColor",
    strokeWidth: 1.055,
    strokeMiterlimit: 10
  })));
}

export default SvgCart;